<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import DATABASE from "@/assets/pic/DATABASE.png";
</script>

<template>
  <div class="flex flex-col min-h-screen bg-gradient-to-b from-white to-blue-50">
    <index-navbar/>

    <!-- 主体部分 -->
    <section class="relative pt-24 pb-16 flex-grow flex items-center">
      <div class="container mx-auto flex flex-wrap items-center px-6 md:px-12">
        <!-- 左侧文本 -->
        <div class="w-full lg:w-6/12 xl:w-5/12 mb-10 lg:mb-0 mt-4">
          <h2 class="font-bold text-4xl text-blueGray-700 mb-6 leading-snug">
            CHBNexus
          </h2>

          <div class="bg-white/80 p-6">
            <p class="text-blueGray-600 text-base leading-relaxed text-justify">
              <span class="font-semibold">CHBNexus</span> is a comprehensive knowledgebase designed to advance Chronic Hepatitis B research by integrating public omics data, literature-derived evidence, and target-related annotations. We provide researchers with a unified platform to explore gene expression patterns, identify key driver genes, investigate molecular interaction networks, and discover potential therapeutic targets in CHB.
            </p>
          </div>
        </div>

        <!-- 右侧图片 -->
        <div class="w-full lg:w-6/12 xl:w-7/12 flex justify-center">
          <img
            :src="DATABASE"
            alt="MigraineNexus Database"
            class="rounded-2xl shadow-2xl max-w-md lg:max-w-lg xl:max-w-2xl transition-transform duration-500 hover:scale-105"
          />
        </div>
      </div>
    </section>

    <footer-component/>
  </div>
</template>
